export default __webpack_public_path__ + "fd9bd63cf1dbc5fe394f568801f7daeb.png";